var render, staticRenderFns
import script from "./EstimateInspectionCostComponent.vue?vue&type=script&lang=ts&"
export * from "./EstimateInspectionCostComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateInspectionCostComponent.vue?vue&type=style&index=0&id=670c64e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c64e6",
  null
  
)

export default component.exports